import { REGION_PAGE } from "routes/route.constant";
import Region from "./Region";

const route = {
  path: REGION_PAGE,
  element: Region,
};

export default route;
